const DESKTOP_DESIGN_TYPE = {
    'native':  'Native Opt-in',
    'DB' :  'Slide Down',
    'CM' :  'Pop Up',
    'FS' :  'Overlay',
    'RS' :  'Sticky',
    'SH' :  'Top Sticky',
    'SUB' : 'Slide Up Box',
    'SB' :  'Sticky Bar',
    'SF' :  'Sticky Footer',
};

const MOBILE_DESIGN_TYPE = {
    'native':  'Native Opt-in',
    'DB' :  'Dialog Box',
    'CM' :  'Pop Up',
    'FS' :  'Overlay',
    'RS' :  'Sticky',
    'SH' :  'Slide Down',
    'SUB' : 'Message Box',
    'SB' :  'Sticky Bar',
    'SF' :  'Sticky Footer',
};

export {DESKTOP_DESIGN_TYPE, MOBILE_DESIGN_TYPE}